import { toast } from "react-toastify";
import { macroDataClient } from "./macroDataClient";

/**
 * La promotion des sujets macroéconomiques modifiés vers la production, en UN seul endroit :
 * la carte permanente de l'écran et la modale qui suit un import s'en servent toutes les deux,
 * donc elles publient de la même façon et annoncent la même chose.
 *
 * <p>Cette forme LÈVE quand l'appel échoue : c'est celle que veut un appelant qui affiche
 * l'erreur lui-même, comme le bouton de la modale. Un appelant qui n'a que des toasts prend
 * {@link publierEnProductionEtSignaler}.</p>
 */
export const publierEnProduction = async (): Promise<void> => {
	const result = await macroDataClient.publishProduction();
	if (result.failed > 0) {
		toast.error(`${result.failed} promotion(s) en échec : consultez le journal de déploiement.`);
	} else {
		toast.success(`${result.deployed} promu(s) · ${result.skipped} inchangé(s).`);
	}
};

/** Le message à montrer quand la promotion a été refusée (verrou de publication compris). */
export const messageEchecPromotion = (err: any): string =>
	err?.response?.status === 409
		? `Publication déjà en cours (${err?.response?.data?.lockedBy ?? "un autre éditeur"}). Réessayez dans quelques minutes.`
		: err?.response?.data?.message ?? "La publication en production a échoué.";

/**
 * Le même geste, mais dont l'échec est déjà transformé en toast. Rend `true` quand la promotion
 * a abouti, `false` quand elle a été refusée.
 */
export const publierEnProductionEtSignaler = async (): Promise<boolean> => {
	try {
		await publierEnProduction();
		return true;
	} catch (err: any) {
		const message = messageEchecPromotion(err);
		if (err?.response?.status === 409) toast.warn(message);
		else toast.error(message);
		return false;
	}
};
